import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { invoiceFiltersSchema } from './schemas';

export const invoiceFiltersQueryOptions = queryOptions({
  queryKey: QueryKeys.invoices.index.filters,
  queryFn: async () => {
    const { data: filters } = await fetchJson('/invoices/filters', {
      schema: apiResourceSchema(invoiceFiltersSchema),
    });

    return filters;
  },
  staleTime: 5 * 60 * 1000,
  gcTime: Infinity,
});

export const useInvoiceFilters = () => {
  return useSuspenseQuery(invoiceFiltersQueryOptions);
};
